import { render, staticRenderFns } from "./BodyAnswer.vue?vue&type=template&id=46b78934&scoped=true&"
import script from "./BodyAnswer.vue?vue&type=script&lang=js&"
export * from "./BodyAnswer.vue?vue&type=script&lang=js&"
import style0 from "./BodyAnswer.vue?vue&type=style&index=0&id=46b78934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b78934",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSheet})
